import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { forkJoin, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { ClienteEquipamento } from 'src/app/modules/painel/modules/clientes/interfaces/cliente-equipamento';
import { ClienteEquipamentosService } from 'src/app/modules/painel/modules/clientes/services/cliente-equipamentos.service';
import { Equipamento } from 'src/app/modules/painel/modules/equipamentos/interfaces/equipamento';
import { EquipamentoService } from 'src/app/modules/painel/modules/equipamentos/services/equipamento.service';
import { AlertService } from '../../alert/alert.service';

@Component({
  selector: 'app-select-equipamentos-cliente',
  templateUrl: './select-equipamentos-cliente.component.html',
  styleUrls: ['./select-equipamentos-cliente.component.scss']
})
export class SelectEquipamentosClienteComponent implements OnInit {

  constructor(
    private alertService: AlertService,
    public equipamentoService: EquipamentoService,
    public clienteEquipService: ClienteEquipamentosService
  ) { }

  @Input() clienteId: number;
  @Input() multiple: boolean = false;
  @Input() required: boolean = true;
  @Input() categoriaEquipamentoId: number = null;

  @Input('myModel') model: any;
  @Output('myModelChange') onModelChange: EventEmitter<any> = new EventEmitter();

  loading: boolean = true;
  selectOptions: any[] = [];
  placeholder: string;

  @ViewChild('selectEquipCliente', { static: true }) selectEquipCliente: NgSelectComponent;
  private selectEquipClienteTouched: boolean = false;

  ngOnInit() {
    this.getEquipamentos();

    this.placeholder = this.multiple ? '-- Selecione os equipamentos --' : '-- Selecione o equipamento --';

    this.selectEquipCliente.closeEvent
      .subscribe(() => this.selectEquipClienteTouched = true);
  }

  private getEquipamentos() {
    forkJoin([
      this.clienteEquipService.getAllByCliente(this.clienteId, this.categoriaEquipamentoId ? { categoria_equipamento_id: this.categoriaEquipamentoId } : {}),
      this.categoriaEquipamentoId ? this.equipamentoService.getByCategoria(this.categoriaEquipamentoId) : this.equipamentoService.getAll()
    ])
      .pipe(take(1), finalize(() => this.loading = false))
      .subscribe(response => {
        const [equipamentosCliente, equipamentos] = response;

        this.selectOptions = equipamentosCliente.map(equipCliente => ({ ...equipCliente, nome: equipCliente.equipamento.nome, grupo: 'Equipamentos do cliente' }));
        this.selectOptions = this.selectOptions.concat(equipamentos.map(equip => ({ ...equip, grupo: 'Equipamentos gerais' })));
      }, (error: HttpErrorResponse) => {
        this.alertService.error(error.error, error.status);
      });
  }

  customSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");

    return (item.nome && item.nome.toLocaleLowerCase().includes(term)) ||
      (item.numero_serie && item.numero_serie.toLocaleLowerCase().includes(term)) ||
      (item.ambiente && item.ambiente.identificacao.toLocaleLowerCase().includes(term));
  }

  get hasError() {
    return this.required && !this.model && this.selectEquipClienteTouched;
  }
}
